module.exports = __webpack_public_path__ + "img/baoxian@3x.411d1f2f.png";